import CDNImageController from "./CDNImageController";
import CDNImageUI from "./CDNImageUI";
import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

export default class CDNImage extends Plugin {
    static get requires() {
        return [ CDNImageController, CDNImageUI ];
    }
}